import { render, staticRenderFns } from "./Content_website.vue?vue&type=template&id=13dd42bd&scoped=true"
import script from "./Content_website.vue?vue&type=script&lang=js"
export * from "./Content_website.vue?vue&type=script&lang=js"
import style0 from "./Content_website.vue?vue&type=style&index=0&id=13dd42bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd42bd",
  null
  
)

export default component.exports